import { gql } from "graphql-tag";

export const ImportListMutation = gql`
  mutation ImportListCSVMutation($id: ID!, $csv: String!, $csvFileName: String) {
    importInterestList(id: $id, csv: $csv, csvFileName: $csvFileName) {
      success
      queued
    }
  }
`;

export const InterestListsQuery = gql`
  query InterestListsWithOrgQuery {
    interestLists {
      id
      name

      organization {
        id
        name
      }
    }
  }
`;
